import styled from 'styled-components';
import { rem } from 'polished';

const baseFont = '12px';
const S = {};

const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;

const InputErrorColor = ({theme: {$inputErrorColor}}) => `${$inputErrorColor}`;
const InputColor = ({theme: {$inputColor}}) => `${$inputColor}`;
const InputLabelColor = ({theme: {$inputLabelColor}}) => `${$inputLabelColor}`;
const InputPlaceholderColor = ({theme: {$inputPlaceholderColor}}) => `${$inputPlaceholderColor}`;
const InputBackgroundColor = ({theme: {$inputBackgroundColor}}) => `${$inputBackgroundColor}`;
const SubmitButtonTextColor = ({theme: {$submitButtonTextColor}}) => `${$submitButtonTextColor}`;
const FooterTextColor = ({theme: {$footerTextColor}}) => `${$footerTextColor}`;

S.FieldsGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${rem('16px')};
    margin-bottom: ${rem('20px')};
`;

S.InputWrapper = styled.div`
    position: relative;
    width: 100%;
    grid-column: ${props => props.fullWidth ? '1 / span 2' : 'auto'};
`;

S.Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    height: ${rem('40px')};
    padding: 0 ${rem('16px')};
    border-radius: 4px;
    font-size: ${rem('14px')};
    background: ${InputBackgroundColor};
    transition: border-color 0.2s;

    border: 1px solid ${props => props.hasError ? InputErrorColor : InputColor};

    &:focus {
        outline: none;
        border-color: ${props => props.hasError ? InputErrorColor : InputColor};
    }

    &:disabled {
        color: ${InputPlaceholderColor};
        cursor: not-allowed;
        border-color: ${InputColor};
    }

    &::placeholder {
        color: ${InputPlaceholderColor};
    }
`;

S.FloatingLabel = styled.span`
    position: absolute;
    top: -8px;
    left: 12px;
    background: ${InputBackgroundColor};
    padding: 0 4px;
    font-size: ${rem('10px')};
    color: ${InputLabelColor};
`;

S.CheckIcon = styled.span`
    color: ${InputLabelColor};
    font-size: ${rem('16px')};
    pointer-events: none;
`;

S.ErrorText = styled.div`
    color: ${InputErrorColor};
    font-size: ${rem('10px')};
    margin-top: ${rem('2px')};
`;

S.SubmitBtn = styled.button`
    width: 100%;
    height: ${rem('40px')};
    font-size: ${rem('14px')};
    background-color: ${InputErrorColor};
    color: ${SubmitButtonTextColor};
    border: none;
    border-radius: 3px;
    font-weight: ${FwSemibold};
    margin-top: ${rem('20px')};
    cursor: pointer;
    text-transform: uppercase;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

S.FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem('4px')};
    margin-top: ${rem('24px')};
    text-align: center;
`;

S.ContactInfo = styled.div`
    font-size: ${rem('12px')};
    color: ${FooterTextColor};
`;

S.ContactLink = styled.span`
    color: ${InputErrorColor};
    font-weight: ${FwSemibold};
    font-size: ${rem('12px')};
    cursor: pointer;
`;

export default S;